import { Injectable } from '@angular/core';
import {SelectedOfferService} from './impl/section-services/selected-offer/selected-offer.service';
import {AdditionalInformationStateService} from './impl/section-services/additional-information/additional-information-state.service';
import {DialogService} from './dialog.service';
import {DialogKey} from '../../shared/components/dialogs/dialogs-configuration';
import {VehicleQuestionCode} from '../consts/vehicle-question-code.enum';

@Injectable({
  providedIn: 'root'
})
export class UniqaExceptionService {

  constructor(private selectedOfferService: SelectedOfferService,
              private additionalInformationStateService: AdditionalInformationStateService,
              private dialogService: DialogService) {
  }

  isValid(): boolean {
    if (this.selectedOfferService.hasAC() && this.wasImportedFromUsaOrCanada()) {
      this.openExceptionDialog();
      return true;
    } else {
      return false;
    }
  }

  private wasImportedFromUsaOrCanada(): boolean {
    const usaCanadaRegistrationQuestion = this.additionalInformationStateService.vehicleData.questions.find(({ questionCode }) => questionCode === VehicleQuestionCode.usaCanadaRegistration);
    return usaCanadaRegistrationQuestion ? usaCanadaRegistrationQuestion.questionAnswer.toUpperCase().endsWith('YES') : false;
  }

  private openExceptionDialog(): void {
    this.dialogService.open(DialogKey.USA_CANADA_IMPORTED_WITH_AC_EXCEPTION);
  }
}
